import { BreakpointService } from '@/common/services/breakpoint/breakpoint.service';
import { CurrentReservationService } from '@/common/services/reservation/current';
import { SsrService } from '@/common/services/ssr/ssr.service';
import {
    resolveAutoHour,
    validateScheduleHourAvailability,
} from '@/common/utils/reservation/schedule.utils';
import { ValidationService } from '@/common/services/validation/validation.service';
import { fromJSDateToInputDate } from '@/common/utils/date/fromJSDateToInputDate';
import { fromJSDateToISODate } from '@/common/utils/date/fromJSDateToISODate';
import { isValid } from '@/common/utils/validation/common.utils';
import { BranchParams } from '@/core/domain/branches/models/branch.model';
import { FindBranchesUseCase } from '@/core/domain/branches/usecases/findBranches.usecase';
import { FindLocationsUseCase } from '@/core/domain/locations/usecases/findLocations.usecase';
import { FindSchedulesUseCase } from '@/core/domain/locations/usecases/findSchedules.usecase';
import { ClearReservationUseCase } from '@/core/domain/reservation/usecases/clearReservation.usecase';
import { SaveReservationUseCase } from '@/core/domain/reservation/usecases/saveReservation.usecase';
import { saveDifferentLocations } from '@/core/reservation/store/differentLocations.actions';
import { saveEndHours } from '@/core/reservation/store/end-hours.actions';
import { saveLocations } from '@/core/reservation/store/locations.actions';
import { saveStartHours } from '@/core/reservation/store/start-hours.actions';
import { saveVehicles } from '@/core/reservation/store/vehicles.actions';
import {
    Component,
    Inject,
    Input,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    ValidatorFn,
    Validators,
} from '@angular/forms';
import { Store } from '@ngrx/store';
import _ from 'lodash';
import { switchMap, catchError, throwError, tap } from 'rxjs';
import { InputComponent } from '../../ui/input/input.component';
import { Router } from '@angular/router';
import { Location } from '@/core/domain/locations/models/location.model';
import { AlertService } from '@/common/services/alert/alert.service';
import { FindBranchesInternationalUseCase } from '@/core/domain/branches-international/usecases/findBranchesInternational.usecase';
import { GetAvailabilityInternationalUseCase } from '@/core/domain/branches-international/usecases/getAvailabilityInternational.usecase';
import { SaveLocationIntUseCase } from '@/core/domain/branches-international/usecases/saveLocationInt.usecase';
import { ClearLocationIntUseCase } from '@/core/domain/branches-international/usecases/clearLocationInt.usecase';
import { saveLocationInt } from '@/core/international/store/international.actions';
import { BranchIntParams } from '@/core/domain/branches-international/models/branch-international.model';
import { DateTime } from 'luxon';
import { UrlService } from '@/common/services/url/url.service';
import { ConfigurationService } from '@/common/services/configuration/configuration.service';
import { UpdateReservationUseCase } from '@/core/domain/reservation/usecases/updateReservation.usecase';
import { NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

type HoursTarget = 'start' | 'end' | 'both';

@Component({
    selector: 'fe-search-reservation',
    templateUrl: './search-reservation.component.html',
    styleUrls: ['./search-reservation.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class SearchReservationComponent implements OnInit {
    public form!: FormGroup;

    public startDate: Date | null = null;

    public endDate: Date | null = null;

    public discountCode = null;

    @ViewChild('inputLocation') inputLocation!: InputComponent;
    @ViewChild('inputDifferentLocation')
    inputDifferentLocation!: InputComponent;
    @ViewChild('inputStartDate') inputStartDate!: InputComponent;
    @ViewChild('inputStartHour') inputStartHour!: InputComponent;
    @ViewChild('inputEndDate') inputEndDate!: InputComponent;
    @ViewChild('inputEndHour') inputEndHour!: InputComponent;
    @ViewChild('inputAge') inputAge!: InputComponent;
    FindBranchesUseCase: any;

    public textNotFoundLocations: string | null = null;
    public textNotFoundDifferentLocations: string | null = null;

    public loadingLocations = false;

    public loadingDifferentLocations = false;

    public loadingStartHours = false;

    public loadingEndHours = false;

    @Input() isNormal = false;
    @Input() isSmall = false;
    @Input() showViewCancel = true;
    @Input() home = false;

    @Input() container: 'container' | 'container-fluid' = 'container';

    public loadingBtnSearch = false;

    public minDifferenceDateValidator: ValidatorFn | null = null;

    public showCouponInput = true;

    timeZone = 'America/Mazatlan';
    today: NgbDateStruct | undefined;
    fromDate: NgbDate | null = null;
    toDate: NgbDate | null = null;
    wasDisabled = false;
    private isAutoSelectingHour = false;
    private isLocationChange = false;
    // isSelecting = false;

    constructor(
        private readonly formBuilder: FormBuilder,
        private readonly findLocationsUseCase: FindLocationsUseCase,
        private readonly findbranchesUseCase: FindBranchesUseCase,
        private readonly store: Store,
        private readonly router: Router,
        private readonly validation: ValidationService,
        public reservation: CurrentReservationService,
        private readonly saveReservationUseCase: SaveReservationUseCase,
        private readonly clearReservationUseCase: ClearReservationUseCase,
        private readonly findSchedulesUseCase: FindSchedulesUseCase,
        private readonly alert: AlertService,
        private readonly findBranchesInternationalUseCase: FindBranchesInternationalUseCase,
        private readonly getAvailabilityInternational: GetAvailabilityInternationalUseCase,
        private readonly saveLocationIntUseCase: SaveLocationIntUseCase,
        private readonly clearLocationIntUseCase: ClearLocationIntUseCase,
        public readonly configuration: ConfigurationService,
        private updateReservation: UpdateReservationUseCase,
        private url: UrlService,
        private readonly ssr: SsrService,
        public readonly breakpoint: BreakpointService,

        @Inject('INPUT_DATEPICKER') public inputDatePickerFormat: string,
    ) {
        this.initForm();
        this.initReservation();
    }

    public ngOnInit(): void {
        this.reset();
    }

    private reset(): void {
        this.reservation.current.differentLocation = [];
        this.reservation.current.location = [];
        this.reservation.current.discountCode =
            this.reservation.current.discountCode ?? null;
        this.reservation.current.endDate = null;
        this.reservation.current.endHour = null;
        this.reservation.current.startDate = null;
        this.reservation.current.startHour = null;
        this.reservation.locations = [];
        this.reservation.showDifferenteLocation = false;
        this.form.reset();
        this.reservation.current.age = 25;
    }

    private initForm(): void {
        this.form = this.formBuilder.group(
            {
                location: [[], Validators.compose([Validators.required])],
                differentLocation: [
                    '',
                    Validators.compose([Validators.required]),
                ],
                startDate: ['', Validators.compose([Validators.required])],
                startHour: ['', Validators.compose([Validators.required])],
                endDate: ['', Validators.compose([Validators.required])],
                endHour: ['', Validators.compose([Validators.required])],
                age: ['', Validators.compose([Validators.required])],
            },
            {
                validators: [
                    this.validation.mismatchingControls(
                        'location',
                        'differentLocation',
                    ),
                    this.validation.maxDifferenceDates(
                        'startDate',
                        'endDate',
                        31,
                    ),
                    this.validation.isGreaterThanDatetime(
                        'startDate',
                        'startHour',
                        'endDate',
                        'endHour',
                    ),
                ],
            },
        );
        const date = new Date(
            new Intl.DateTimeFormat('en-US', {
                timeZone: this.timeZone,
            }).format(),
        );
        this.today = {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate(),
        };
    }

    private initReservation(): void {
        this.clearReservationUseCase.execute().subscribe();
    }

    public onClickBtnAfter(event: any): void {
        this.reservation.showDifferenteLocation =
            !this.reservation.showDifferenteLocation;
        this.reservation.current.differentLocation = null;
        this.form.get('differentLocation')?.reset(null);
        this.form.updateValueAndValidity();
        this.toggleSelectLocations();

        if (!this.reservation.showDifferenteLocation) {
            this.checkeLocationDates(this.hoursTargetOnLocationChange());
        }
    }

    protected toggleSelectLocations(): void {
        if (this.reservation.showDifferenteLocation) {
            setTimeout(() => {
                this.inputDifferentLocation.getSelectComponent().open();
            });
            return;
        }
        this.reservation.differentLocations = [];
    }

    public onChangeLocation(): void {
        this.isLocationChange = true;
        this.updateValidators();
        this.checkeLocationDates(this.hoursTargetOnLocationChange());
    }

    private hoursTargetOnLocationChange(): HoursTarget {
        return isValid(this.reservation.current.endDate) ? 'both' : 'start';
    }

    protected updateValidators(): void {
        if (this.minDifferenceDateValidator !== null) {
            this.form.removeValidators(this.minDifferenceDateValidator);
            this.form.updateValueAndValidity();
        }

        const location = _.find(
            this.reservation.locations,
            (item: any) =>
                item.id === _.first(this.reservation.current.location),
        ) as Location | undefined;

        if (!location) {
            return;
        }

        this.showCouponInput = location.location === 'NAT';

        if (location.minDays === 0) {
            return;
        }

        this.minDifferenceDateValidator = this.validation.minDifferenceDates(
            'startDate',
            'startHour',
            'endDate',
            'endHour',
            location.minDays as number,
        );
        this.form.addValidators(this.minDifferenceDateValidator);
        this.form.updateValueAndValidity();
    }

    public onSearchLocations(term: string): void {
        this.loadingLocations = true;
        const searchTerm = this.resolveSearchTerm(term);
        this.findLocationsUseCase
            .execute({ searchTerm })
            .subscribe((locations) => {
                this.loadingLocations = false;
                this.reservation.locations = locations.data as {
                    [key: string]: unknown;
                }[];
                this.checkTextLabelLocations(term);
                this.store.dispatch(
                    saveLocations({ value: this.reservation.locations }),
                );
            });
    }

    private checkTextLabelLocations(term: string): void {
        this.textNotFoundLocations =
            term.length >= 3 && this.reservation.locations.length === 0
                ? 'No se han obtenido resultados'
                : null;
    }

    public onSearchDifferentLocations(term: string): void {
        this.loadingDifferentLocations = true;
        const searchTerm = this.resolveSearchTerm(term);
        const locationId = _.first(this.reservation.current.location);
        this.findLocationsUseCase
            .execute({
                searchTerm,
                isPickupInternational: _.some(
                    this.reservation.locations,
                    (item: Location) =>
                        item.id === locationId && item.location === 'INT',
                ),
                isReturn: true,
                pickupLocationId: locationId,
            })
            .subscribe((locations) => {
                this.loadingDifferentLocations = false;
                this.reservation.differentLocations = locations.data as {
                    [key: string]: unknown;
                }[];
                this.checkTextLabelDifferentLocations(term);
                this.store.dispatch(
                    saveDifferentLocations({
                        value: this.reservation.differentLocations,
                    }),
                );
            });
    }

    private checkTextLabelDifferentLocations(term: string): void {
        this.textNotFoundDifferentLocations =
            term.length >= 3 && this.reservation.differentLocations.length === 0
                ? 'No se han obtenido resultados'
                : null;
    }

    public onSelectedDateStart(date: any): void {
        this.setDates(date);
    }

    public onSelectedDateEnd(date: any): void {
        this.setDates(date);
    }

    private setDates(date: any): void {
        this.isLocationChange = false;
        this.startDate = date.start;
        this.endDate = date.end;
        this.reservation.current.startDate = fromJSDateToInputDate(date.start);
        this.reservation.current.endDate = fromJSDateToInputDate(date.end);
        this.checkeLocationDates('both');
    }

    protected checkeLocationDates(target: HoursTarget = 'start'): void {
        //this.resetHours();
        setTimeout(() => {
            const hasLocationAndStartDate =
                isValid(this.reservation.current.location) &&
                isValid(this.reservation.current.startDate);

            if (
                hasLocationAndStartDate &&
                !this.form.hasError('differenceDatesOut') &&
                !this.form.hasError('lessThanDate')
            ) {
                this.fetchSchedules(this.onGetSchedules.bind(this), target);
            } else if (!hasLocationAndStartDate) {
                this.resetHours();
            }
        });
    }

    private resetHours(options: { keepStartHour?: boolean } = {}): void {
        if (!options.keepStartHour) {
            this.reservation.current.startHour = null;
        }
        this.reservation.current.endHour = null;
        this.reservation.startHours = options.keepStartHour
            ? this.reservation.startHours
            : [];
        this.reservation.endHours = [];
    }
    private restoreStartHourState(): void {
        setTimeout(() => {
            if (this.inputStartHour?.getSelectComponent()) {
                this.inputStartHour
                    .getSelectComponent()
                    .setDisabledState(this.wasDisabled === true);
            }
        });
    }

    private fetchSchedules(
        callback: (response: any) => void,
        target: HoursTarget,
    ): void {
        if (
            this.reservation.showDifferenteLocation &&
            !isValid(_.first(this.reservation.current.differentLocation))
        ) {
            this.restoreStartHourState();
            return;
        }
        const branch = _.find(
            this.reservation.locations,
            (item) => item.id === _.first(this.reservation.current.location),
        );

        if (!branch) {
            this.restoreStartHourState();
            return;
        }

        this.loadingStartHours = target !== 'end';
        this.loadingEndHours = target !== 'start';

        const typeReservation = branch.location === 'INT' ? 'INT' : 'NAT';

        this.findSchedulesUseCase
            .execute({
                id: _.first(this.reservation.current.location) as string,
                idReturn: this.reservation.showDifferenteLocation
                    ? _.first(this.reservation.current.differentLocation)
                    : _.first(this.reservation.current.location),
                location: typeReservation,
                pickup: `${fromJSDateToISODate(this.startDate as Date)}T${DateTime.now().toFormat('HH:mm:ss')}`,
                return: `${fromJSDateToISODate(this.endDate as Date)}T${DateTime.now().toFormat('HH:mm:ss')}`,
            })
            .pipe(
                catchError((error) => {
                    this.stopLoadingHours();
                    this.resetHours({ keepStartHour: true });
                    setTimeout(() => {
                        if (this.inputStartHour?.getSelectComponent()) {
                            this.inputStartHour
                                .getSelectComponent()
                                .setDisabledState(this.wasDisabled);
                        }
                    }, 0);
                    this.alert
                        .open({
                            title: this.alert.getErrorTitle(error),
                            subtitle: this.alert.getErrorMessage(error),
                            showCancel: false,
                        })
                        .subscribe();
                    return throwError(() => error);
                }),
                tap((schedulesResponse) => {
                    callback(schedulesResponse);

                    // Restaurar el estado original después del tap
                    setTimeout(() => {
                        if (this.inputStartHour?.getSelectComponent()) {
                            this.inputStartHour
                                .getSelectComponent()
                                .setDisabledState(this.wasDisabled);
                        }
                    }, 0);
                }),
            )
            .subscribe();
    }

    private stopLoadingHours(): void {
        this.loadingStartHours = false;
        this.loadingEndHours = false;
    }

    private onGetSchedules(hours: any): void {
        this.stopLoadingHours();
        this.reservation.startHours = _.get(hours, 'data.schedules.pickup', []);
        if (!isValid(this.reservation.current.discountCode)) {
            this.reservation.current.discountCode = _.get(
                hours,
                'data.coupons.0',
                '',
            );
        }
        // eslint-disable-next-line @ngrx/avoid-dispatching-multiple-actions-sequentially
        this.store.dispatch(
            saveStartHours({ value: this.reservation.startHours }),
        );
        this.reservation.endHours = _.get(hours, 'data.schedules.return', []);
        // eslint-disable-next-line @ngrx/avoid-dispatching-multiple-actions-sequentially
        this.store.dispatch(saveEndHours({ value: this.reservation.endHours }));
        this.autoSelectStartHour();
        this.autoSelectEndHour();
        this.validateSelectedHours();

        if (!this.reservation.current.endDate) {
            setTimeout(() => {
                if (this.reservation.startHours.length > 0 && !this.reservation.current.startHour) {
                    this.inputStartHour.focus();
                }
            }, 100);
        }
    }

    private focusToInvalid(): void {
        if (this.form.get('location')?.invalid) {
            this.inputLocation.focus();
            return;
        }
        if (
            this.reservation.showDifferenteLocation &&
            this.form.get('differentLocation')?.invalid
        ) {
            this.inputDifferentLocation.focus();
            return;
        }
        if (this.form.get('startDate')?.invalid) {
            this.inputStartDate.focus();
            return;
        }
        if (this.form.get('startHour')?.invalid) {
            this.inputStartHour.focus();
            return;
        }
        if (this.form.get('endDate')?.invalid) {
            this.inputEndDate.focus();
            return;
        }
        if (this.form.get('endHour')?.invalid) {
            this.inputEndHour.focus();
            return;
        }
        if (this.form.get('age')?.invalid) {
            this.inputAge.focus();
            return;
        }
    }

    public onClickSearch(): void {
        this.form.markAllAsTouched();

        if (!this.reservation.showDifferenteLocation) {
            this.form.get('differentLocation')?.setErrors(null);
        }

        if (!this.form.valid) {
            this.focusToInvalid();
            return;
        }
        const branch = _.find(
            this.reservation.locations,
            (item) => item.id === _.first(this.reservation.current.location),
        );

        if (!branch) {
            this.inputLocation.focus();
            return;
        }

        const locationInfo: BranchParams = {
            id_sucursal_renta: _.first(this.reservation.current.location),
            id_sucursal_devolucion: _.first(
                this.reservation.current.differentLocation,
            ),
            fRenta: this.reservation.current.startDate,
            hRenta: this.reservation.current.startHour,
            fDevolucion: this.reservation.current.endDate,
            hDevolucion: this.reservation.current.endHour,
            cupon: this.reservation.current.discountCode,
        };

        const locationInt: BranchIntParams = {
            id: _.first(this.reservation.current.location),
            returnBranchId: _.first(this.reservation.current.differentLocation),
            location: branch.location,
            fRenta: this.reservation.current.startDate,
            hRenta: this.reservation.current.startHour,
            fDevolucion: this.reservation.current.endDate,
            hDevolucion: this.reservation.current.endHour,
            type: branch.group,
        };

        if (isValid(this.reservation.current.age)) {
            locationInt.age = this.reservation.current.age as unknown as string;
        }

        const branchIntParams: BranchIntParams = {
            id: _.first(this.reservation.current.location),
            returnBranchId: _.first(this.reservation.current.differentLocation),
            location: branch.location,
            lat: branch.gps.latitude,
            lon: branch.gps.longitude,
            fRenta: this.reservation.current.startDate,
            hRenta: this.reservation.current.startHour,
            fDevolucion: this.reservation.current.endDate,
            hDevolucion: this.reservation.current.endHour,
            type: branch.group,
        };

        if (isValid(this.reservation.current.age)) {
            branchIntParams.age = this.reservation.current
                .age as unknown as string;
        }

        this.clearLocationIntUseCase.execute();
        this.loadingBtnSearch = true;

        if (branch.location === 'INT') {
            this.reservation.current.origin = 'INT';
            if (branch.group === 'city') {
                this.saveReservationUseCase
                    .execute()
                    .pipe(
                        switchMap((response) => {
                            return this.updateReservation.execute({
                                cityInternational: branch,
                            });
                        }),
                    )
                    .subscribe();
                this.store.dispatch(
                    saveLocationInt({
                        value: branchIntParams,
                    }),
                );
                this.loadingBtnSearch = false;
                this.router.navigate([
                    this.url.format('international-reservations/branch-search'),
                ]);
                return;
            } else {
                this.getAvailabilityInternational
                    .execute(locationInt)
                    .pipe(
                        catchError((error) => {
                            this.loadingBtnSearch = false;
                            this.alert.openDefault(error);
                            return throwError(() => error);
                        }),
                    )
                    .subscribe((locations) => {
                        this.loadingBtnSearch = false;
                        this.saveReservationUseCase.execute().subscribe();
                        this.store.dispatch(
                            saveVehicles({ value: locations.data }),
                        );
                        this.router.navigate(
                            [
                                this.url.format(
                                    'reservations/cars-and-categories',
                                ),
                            ],
                            {
                                state: {
                                    international: true,
                                },
                            },
                        );
                    });
                return;
            }
        } else {
            this.reservation.current.origin = 'NAT';
            this.findbranchesUseCase
                .execute(locationInfo)
                .pipe(
                    catchError((error) => {
                        this.loadingBtnSearch = false;
                        this.alert.openDefault(error);
                        return throwError(() => error);
                    }),
                )
                .subscribe((locations) => {
                    this.loadingBtnSearch = false;
                    this.saveReservationUseCase.execute().subscribe();
                    this.store.dispatch(
                        saveVehicles({ value: locations.data }),
                    );
                    this.router.navigate([
                        this.url.format('reservations/cars-and-categories'),
                    ]);
                });
        }
    }

    public onPromoApplied(code: string): void {
        this.reservation.current.discountCode = code;
    }

    onFromDateChange(date: NgbDate | null): void {
        this.isLocationChange = false;
        this.fromDate = date;
        if (date) {
            this.startDate = new Date(date.year, date.month - 1, date.day);
            const hasEndDate = isValid(this.reservation.current.endDate);
            const endNotAfterStart =
                !!this.endDate && this.endDate <= this.startDate;
            if (!hasEndDate || endNotAfterStart) {
                this.endDate = new Date(
                    date.year,
                    date.month - 1,
                    date.day + 1,
                );
                if (hasEndDate) {
                    this.toDate = new NgbDate(
                        this.endDate.getFullYear(),
                        this.endDate.getMonth() + 1,
                        this.endDate.getDate(),
                    );
                    this.reservation.current.endDate = fromJSDateToInputDate(
                        this.endDate,
                    );
                } else {
                    this.reservation.current.endDate = null;
                }
                this.reservation.current.endHour = null;
            }

            this.reservation.current.startDate = fromJSDateToInputDate(
                this.startDate,
            );

            this.checkeLocationDates();
            if (!isValid(this.reservation.current.startHour)) {
                this.inputStartHour.focus();
            }
        }
    }

    onToHourChange(): void {
        this.validateSelectedHours();
    }

    onFromHourChange(): void {
        this.validateSelectedHours();
        if (
            this.reservation.current.startHour &&
            !this.reservation.current.endDate &&
            !this.isAutoSelectingHour
        ) {
            this.inputEndDate.openCalendar();
        }
    }

    onToDateChange(date: NgbDate | null): void {
        this.isLocationChange = false;
        this.wasDisabled = this.inputStartHour?.getSelectComponent()?.disabled;
        if (this.inputStartHour?.getSelectComponent()) {
            this.inputStartHour.getSelectComponent().setDisabledState(true);
        }
        this.toDate = date;
        if (date) {
            this.endDate = new Date(date.year, date.month - 1, date.day);
            this.reservation.current.endDate = fromJSDateToInputDate(
                this.endDate,
            );
        }
        this.fetchSchedules(this.onGetSchedulesEnd.bind(this), 'end');
        //this.inputEndHour.focus();
    }

    isSelectingChange(isSelecting: boolean): void {
        //this.isSelecting = isSelecting;
    }

    private autoSelectStartHour(): void {
        if (!this.startDate) return;
        if (
            this.isLocationChange &&
            isValid(this.reservation.current.startHour) &&
            !this.reservation.startHours.includes(
                this.reservation.current.startHour as string,
            )
        ) {
            return;
        }
        const match = resolveAutoHour(
            this.reservation.startHours,
            this.startDate,
            this.reservation.current.startHour,
        );
        if (match) {
            this.isAutoSelectingHour = true;
            this.reservation.current.startHour = match;
            this.form.get('startHour')?.setValue(match);
            this.isAutoSelectingHour = false;
        }
    }

    private autoSelectEndHour(): void {
        if (!this.endDate || !isValid(this.reservation.current.endDate)) return;
        if (this.areStartAndEndTodaySameDay()) return;
        if (
            this.isLocationChange &&
            isValid(this.reservation.current.endHour) &&
            !this.reservation.endHours.includes(
                this.reservation.current.endHour as string,
            )
        ) {
            return;
        }
        const match = resolveAutoHour(
            this.reservation.endHours,
            this.endDate,
            this.reservation.current.endHour,
        );
        if (match) {
            this.reservation.current.endHour = match;
            this.form.get('endHour')?.setValue(match);
        }
    }

    private areStartAndEndTodaySameDay(): boolean {
        if (!this.startDate || !this.endDate) {
            return false;
        }
        const today = DateTime.now().startOf('day');
        return (
            DateTime.fromJSDate(this.startDate)
                .startOf('day')
                .hasSame(today, 'day') &&
            DateTime.fromJSDate(this.endDate)
                .startOf('day')
                .hasSame(today, 'day')
        );
    }

    public startHourUnavailable = false;
    public endHourUnavailable = false;

    private validateSelectedHours(): void {
        this.startHourUnavailable = this.isHourUnavailable(
            this.reservation.current.startHour,
            this.reservation.startHours,
        );
        this.endHourUnavailable = this.isHourUnavailable(
            this.reservation.current.endHour,
            this.reservation.endHours,
        );
    }

    private isHourUnavailable(
        hour: string | null | undefined,
        availableHours: string[],
    ): boolean {
        return (
            isValid(hour) &&
            !validateScheduleHourAvailability(hour, availableHours).isAvailable
        );
    }

    public get hasUnavailableHour(): boolean {
        return this.startHourUnavailable || this.endHourUnavailable;
    }

    public get hasBlockingError(): boolean {
        return (
            this.form.hasError('lessThanDate') ||
            this.form.hasError('differenceDatesOut') ||
            this.form.hasError('differenceDatesIn') ||
            this.hasUnavailableHour
        );
    }

    private onGetSchedulesEnd(hours: any): void {
        this.stopLoadingHours();
        this.reservation.endHours = _.get(hours, 'data.schedules.return', []);
        // eslint-disable-next-line @ngrx/avoid-dispatching-multiple-actions-sequentially
        this.store.dispatch(saveEndHours({ value: this.reservation.endHours }));
        this.autoSelectEndHour();
        this.validateSelectedHours();

        setTimeout(() => {
            if (this.reservation.endHours.length > 0 && this.inputEndHour && !this.reservation.current.endHour) {
                // Cerrar cualquier otro selector que pueda estar abierto
                if (this.inputStartHour?.getSelectComponent()?.isOpen) {
                    this.inputStartHour.getSelectComponent().close();
                }
                this.inputEndHour.focus();
            }
        }, 100);
    }

  private resolveSearchTerm(term: string): string {
    const synonyms: Record<string, string> = {
       'cdmx': 'Ciudad de Mexico',
    };
    return synonyms[term.toLowerCase().trim()] || term;
  }
}
